export const BIK_LENGTH = 9;
export const PAYMENT_ACCOUNT_LENGTH = 20;
export const EMPLOYEE_NAME_LENGTH = 60;
export const DOCUMENT_ISSUER_LENGTH = 500;
export const ORGANIZATION_NAME_LENGTH = 500;
export const KBK_LENGTH = 20;
export const ORGANIZATION_ACCOUNT_LENGTH = 11;
export const REGISTRATION_NUMBER_LENGTH = 10;
export const KPP_LENGTH = 9;
export const MAX_RECIPIENT_ACCOUNT_LENGTH = 20;
export const MIN_RECIPIENT_ACCOUNT_LENGTH = 5;
export const PERSON_INN_LENGTH = 12;
export const ORGANIZATION_INN_LENGTH = 10;
